import { DevicesVisible, Layout } from '../../../types';

export const imageSettings = {
  areaWidth: 50,
  imageHeight: 300,
  layout: Layout.RightMedia,
  mobileLayout: Layout.EmbeddedMedia,
  scale: 100,
  ratio: 0,
  mobileScale: 100,
  mobileRatio: 0,
  horizontalSize: 40,
  horizontalSizeOnMobile: 40,
  horizontalBorderRadius: 0,
  verticalBorderRadius: 0,
  visible: true,
  devicesVisible: DevicesVisible.AllDevices
} as const;
